import React, { Component } from 'react';
import FontAwesome from 'react-fontawesome'
import { bool, object } from 'prop-types'

import styles from './Cart.scss';

export default class Cart extends Component {
    state = { visible: true }

    static propTypes = {
        data: object,
        visible: bool,
    }

    componentWillReceiveProps = (nextProps) => {
        this.setState({
            visible: nextProps.visible
        });
    }

    closeClick = () => {
        this.setState({ visible: false });
    }

    render() {
        if (!this.state.visible) {
            return null;
        }

        const {
            data
          } = this.props
        var priceRows = null;
        var totalPrice = 'SEK 0';

        if (data) {
            priceRows = (
                <ul className={styles.items}>
                    {data.PriceRows.map(function(object, i){
                        return (
                            <li key={i}>
                                <span className={styles.name}>{object[0]}</span>
                                <span className={styles.price}>{object[1]}</span>
                            </li>)
                    })}
                </ul>
            );
            totalPrice = data.TotalPrice;
        }

        return (
            <div className={styles.container}>
                <div className={styles.cart}>
                    {priceRows}
                    <div className={styles.header}>
                        <FontAwesome name='shopping-cart' className={styles.icon}/>
                        <div className={styles.total}>
                            <span className={styles.lighter}>Total:&nbsp;</span>
                            <span className={styles.main}>{totalPrice}</span>
                        </div>
                    </div>
                    <div className={styles.close}><a href="javascript:void(0);" onClick={this.closeClick}>close</a></div>
                </div>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./app/components/Cart.js